/* eslint-disable max-len */
/* eslint-disable no-plusplus */
// libraries
import React from 'react';
import {
    Button,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    TextField,
} from '@material-ui/core';
import { CheckCircle, NavigateBefore, Send } from '@material-ui/icons';
import { v4 as uuidv4 } from 'uuid';

// js
import defaultSound from '../../../assets/images/defaultSound.png';
import { allMenuItems } from './taskConstants';
import {
    ContainerAdjustIconEdit,
    ContainerOptions,
    InputNullSelectedPhoto,
    Logo,
    TitleOption,
} from '../modulesStyles';

// interfaces
import type { TaskAssociateWordInterface, DataModuleInterface } from '../modulesInterfaces';
import uploads from '../../../services/uploads';
import tasks from '../../../services/tasks';

const TaskAssociateWord = (
    setIdModal: any,
    initialDataTaskAssociateWord: TaskAssociateWordInterface,
    taskAssociateWord: TaskAssociateWordInterface,
    setTaskAssociateWord: any,
    dataModule: DataModuleInterface,
) => {
    // constants
    const token: any = String(localStorage.getItem('token') || '');
    const adjustMarginBottom = { marginBottom: 10 };
    const adjustButtonLogo = { marginBottom: 25, width: 200 };
    const adjustWidthSelectedActivities = { width: 200 };
    const marginDefault = { marginRight: 10, width: '45%' };

    // methods
    const BackScreenModal = () => {
        setIdModal(1);
        setTaskAssociateWord(initialDataTaskAssociateWord);
    };

    const CreateTask = async () => {
        const formatOptions = taskAssociateWord?.options?.map((e: any) => {
            const option = e;
            delete option?.idWrapperTask;
            return option;
        });
        const formatTask: any = {
            ...taskAssociateWord,
            options: formatOptions,
            idTask: taskAssociateWord.id,
            idModule: dataModule?.id,
        };
        delete formatTask?.id;
        if (formatTask?.idTask) {
            const editTask: any = await tasks.EditTask(formatTask, token);
            if (editTask) {
                BackScreenModal();
            }
        } else {
            delete formatTask?.idTask;
            const createTask: any = await tasks.CreateTask(formatTask, token);
            if (createTask) {
                BackScreenModal();
            }
        }
    };

    const onChangeTitle = (txt: any) => {
        if (txt.target.value.length <= 200) {
            const newDataTask = { ...taskAssociateWord, title: txt.target.value };
            setTaskAssociateWord(newDataTask);
        }
    };

    const onChangeSubtitle = (txt: any) => {
        if (txt.target.value.length <= 200) {
            const newDataTask = { ...taskAssociateWord, subtitle: txt.target.value };
            setTaskAssociateWord(newDataTask);
        }
    };

    const onChangeOptionSkipTask = (txt: any) => {
        const newDataTask = { ...taskAssociateWord, skip: txt.target.value };
        setTaskAssociateWord(newDataTask);
    };

    const validationDisabled = () => {
        let valueObject = true;
        const ValidationOptionsLength = taskAssociateWord?.options.filter((v: any) => v.optionEnglish && v.optionPortuguese && v.file).length === taskAssociateWord?.options?.length;
        if (taskAssociateWord?.id) {
            const ValidationLength = Object.values(taskAssociateWord).filter((v) => v !== '').length !== 7;
            if (!ValidationLength && ValidationOptionsLength) {
                valueObject = false;
            }
        } else if (!taskAssociateWord?.id) {
            const ValidationLength = Object.values(taskAssociateWord).filter((v) => v !== '').length !== 6;
            if (!ValidationLength && ValidationOptionsLength) {
                valueObject = false;
            }
        }
        return valueObject;
    };

    const validationBackground = () => {
        const valueObject = Object.values(taskAssociateWord).filter((v) => v !== '');
        const ValidationOptionsLength = taskAssociateWord?.options.filter((v: any) => v.optionEnglish && v.optionPortuguese && v.file).length === taskAssociateWord?.options?.length;
        if ((taskAssociateWord?.id ? valueObject.length === 7 : valueObject.length === 6) && ValidationOptionsLength) {
            return 'primary';
        }

        return 'inherit';
    };

    const onChangeTarget = (txt: any) => {
        const allOptions = [];
        for (let i = 0; i < Number(txt.target.value); i++) {
            const objOrigin = {
                optionEnglish: '',
                optionPortuguese: '',
                id: uuidv4(),
                file: '',
            };
            allOptions.push(objOrigin);
            if (allOptions.length === Number(txt.target.value)) {
                const orderNewDataOption = allOptions.sort((a, b) => {
                    if (a.id < b.id) return -1;
                    if (a.id > b.id) return 1;
                    return 0;
                });
                const newDataTask = {
                    ...taskAssociateWord,
                    target: Number(txt.target.value),
                    options: orderNewDataOption,
                };
                setTaskAssociateWord(newDataTask);
            }
        }
    };

    // renders
    const RenderSelectedCorrectOptions = (skipTask: boolean) => {
        const options = taskAssociateWord?.options?.filter((v: any) => v?.option !== '')?.length;
        const allOptions = options === taskAssociateWord?.target;

        if (options > 0 && allOptions && !skipTask) {
            return (
                <>
                    <FormControl style={adjustWidthSelectedActivities}>
                        <InputLabel>Pular/Não pular</InputLabel>
                        <Select value={taskAssociateWord.skip} onChange={onChangeOptionSkipTask}>
                            <MenuItem value="true">Pular</MenuItem>
                            <MenuItem value="false">Não pular</MenuItem>
                        </Select>
                    </FormControl>
                </>
            );
        }

        return null;
    };

    const RenderInputsOptions = (label: string, value: string, onChange: any) => {
        const ValueActual = value;
        return (
            <TextField
                label={`${label} (${ValueActual.length}/200)`}
                onChange={onChange}
                style={marginDefault}
                value={value}
            />
        );
    };

    const RenderInputsBody = () => {
        if (taskAssociateWord?.options?.length) {
            return taskAssociateWord.options.map((item: any, index: number) => {
                const indexFormat = index + 1;
                const indexZero = indexFormat < 10 ? 0 : '';
                const [getOneOption] = taskAssociateWord.options.filter(
                    (v: any) => v.id === item.id,
                );
                const removeOneOption = taskAssociateWord.options.filter(
                    (v: any) => v.id !== item.id,
                );

                const onChangeOptionPortuguese = (txt: any) => {
                    if (txt.target.value.length <= 50) {
                        if (getOneOption.id === item.id) {
                            const optionModified = {
                                optionEnglish: getOneOption.optionEnglish,
                                optionPortuguese: txt.target.value,
                                id: getOneOption.id,
                            };
                            const newDataOption = [...removeOneOption, optionModified];
                            const orderNewDataOption = newDataOption.sort((a, b) => {
                                if (a.id < b.id) return -1;
                                if (a.id > b.id) return 1;
                                return 0;
                            });
                            setTaskAssociateWord({
                                ...taskAssociateWord,
                                options: orderNewDataOption,
                            });
                        }
                    }
                };

                const onChangeOptionEnglish = (txt: any) => {
                    if (txt.target.value.length <= 50) {
                        if (getOneOption.id === item.id) {
                            const optionModified = {
                                optionEnglish: txt.target.value,
                                optionPortuguese: getOneOption.optionPortuguese,
                                id: getOneOption.id,
                            };
                            const newDataOption = [...removeOneOption, optionModified];
                            const orderNewDataOption = newDataOption.sort((a, b) => {
                                if (a.id < b.id) return -1;
                                if (a.id > b.id) return 1;
                                return 0;
                            });
                            setTaskAssociateWord({
                                ...taskAssociateWord,
                                options: orderNewDataOption,
                            });
                        }
                    }
                };

                const SelectedPhoto = async (event: any) => {
                    if (event.target.files.length) {
                        const newDataFiles = {
                            eventFile: event.target.files[0],
                            eventName: event.target.files[0].name,
                            file: URL.createObjectURL(event.target.files[0]),
                        };

                        const upload: any = await uploads.UploadFile(newDataFiles.eventFile);
                        if (upload) {
                            const optionModified = {
                                optionEnglish: getOneOption.optionEnglish,
                                optionPortuguese: getOneOption.optionPortuguese,
                                id: getOneOption.id,
                                file: upload.result,
                            };
                            const newDataOption = [...removeOneOption, optionModified];
                            const orderNewDataOption = newDataOption.sort((a, b) => {
                                if (a.id < b.id) return -1;
                                if (a.id > b.id) return 1;
                                return 0;
                            });
                            setTaskAssociateWord({
                                ...taskAssociateWord,
                                options: orderNewDataOption,
                            });
                            // eslint-disable-next-line no-param-reassign
                            event.target.value = null;
                        }
                    }
                };

                return (
                    <ContainerOptions marginTop="10px">
                        {RenderInputsOptions(`Opção ${indexZero}${indexFormat} português`, item.optionPortuguese, onChangeOptionPortuguese)}
                        {RenderInputsOptions(`Opção ${indexZero}${indexFormat} inglês`, item.optionEnglish, onChangeOptionEnglish)}
                        <Button
                            style={adjustButtonLogo}
                            title={item?.file}
                        >
                            <Logo src={defaultSound} />
                            {item?.file ? (
                                <ContainerAdjustIconEdit right="7px" style={adjustMarginBottom}>
                                    <CheckCircle color="inherit" />
                                </ContainerAdjustIconEdit>
                            ) : null}
                            <InputNullSelectedPhoto
                                accept=".mp3,audio/*"
                                onChange={SelectedPhoto}
                                type="file"
                            />
                        </Button>
                    </ContainerOptions>
                );
            });
        }

        return null;
    };

    const RenderAllItems = () => {
        if (allMenuItems.ids.length) {
            return allMenuItems.ids.map((idSelected: any) => (
                <MenuItem value={idSelected}>{idSelected}</MenuItem>
            ));
        }
        return null;
    };

    const RenderInputsTitles = (label: string, value: string, onChange: any) => {
        const ValueActual = value;
        return (
            <>
                <ContainerOptions marginTop="10px" />
                <TextField
                    fullWidth
                    label={`${label} (${ValueActual.length}/200)`}
                    onChange={onChange}
                    value={value}
                />
            </>
        );
    };

    const EndIcon = () => (
        <Send />
    );

    const RenderIconGoBack = () => (
        <NavigateBefore />
    );

    return (
        <>
            <ContainerOptions>
                <TitleOption width="100%">Criação da Atividade - Associe a frase à sua tradução</TitleOption>
            </ContainerOptions>
            {RenderInputsTitles('Título da atividade', taskAssociateWord.title, onChangeTitle)}
            {RenderInputsTitles('Subtítulo da atividade', taskAssociateWord.subtitle, onChangeSubtitle)}
            <FormControl style={adjustWidthSelectedActivities}>
                <InputLabel>Quantidade</InputLabel>
                <Select value={taskAssociateWord.target} onChange={onChangeTarget}>
                    {RenderAllItems()}
                </Select>
            </FormControl>
            {RenderInputsBody()}
            <ContainerOptions marginTop="10px" width="50%">
                {RenderSelectedCorrectOptions(false)}
                {RenderSelectedCorrectOptions(true)}
            </ContainerOptions>
            <ContainerOptions marginTop="40px">
                <Button
                    color="primary"
                    startIcon={RenderIconGoBack()}
                    onClick={BackScreenModal}
                    variant="contained"
                >
                    Voltar
                </Button>
                <Button
                    color={validationBackground()}
                    disabled={validationDisabled()}
                    endIcon={EndIcon()}
                    onClick={CreateTask}
                    variant="contained"
                >
                    {taskAssociateWord?.id ? 'Editar Atividade' : 'Criar Atividade'}
                </Button>
            </ContainerOptions>
        </>
    );
};

export default TaskAssociateWord;
